/* Pia (30.10.2026): Web-Push-Abo je Gerät. Service Worker /pia-sw.js, VAPID-Schlüssel vom Server. */
import api from '@/lib/api';

export const pushMoeglich = () => typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

function schluesselZuBytes(b64) {
  const pad = '='.repeat((4 - (b64.length % 4)) % 4);
  const roh = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from([...roh].map((c) => c.charCodeAt(0)));
}

export async function pushStand() {
  if (!pushMoeglich()) return 'nicht_moeglich';
  if (Notification.permission === 'denied') return 'blockiert';
  try {
    const reg = await navigator.serviceWorker.getRegistration('/pia-sw.js');
    const abo = reg && await reg.pushManager.getSubscription();
    return abo && Notification.permission === 'granted' ? 'an' : 'aus';
  } catch (e) { return 'aus'; }
}

export async function pushAnschalten() {
  const { data } = await api.get('/assistenz/push/schluessel');
  if (!data.konfiguriert || !data.schluessel) throw new Error('Mitteilungen sind auf dem Server noch nicht eingerichtet.');
  const erlaubnis = await Notification.requestPermission();
  if (erlaubnis !== 'granted') throw new Error('Mitteilungen wurden nicht erlaubt.');
  const reg = await navigator.serviceWorker.register('/pia-sw.js');
  await navigator.serviceWorker.ready;
  const abo = (await reg.pushManager.getSubscription())
    || await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: schluesselZuBytes(data.schluessel) });
  const geraet = (navigator.userAgent.match(/(iPhone|iPad|Android|Macintosh|Windows)/) || ['Gerät'])[0];
  await api.post('/assistenz/push/abo', { ...abo.toJSON(), geraet });
}

export async function pushAusschalten() {
  const reg = await navigator.serviceWorker.getRegistration('/pia-sw.js');
  const abo = reg && await reg.pushManager.getSubscription();
  if (abo) {
    await api.post('/assistenz/push/abo/abmelden', { endpoint: abo.endpoint }).catch(() => {});
    await abo.unsubscribe();
  }
}
